<template>
  <li class="mt-8 mb-6">
    <div class="bg-primary-subtle px-6 py-8 tablet:px-12 tablet:py-10">
      <p v-if="status === NewsletterSectionTypes.NewsletterFormStatus.Success" class="txt-headline-2xl-bold text-main">
        {{ $t('newsletter.success_message') }}
      </p>

      <template v-else>
        <div class="pb-4 txt-headline-3xl-bold">
          {{ title }}
        </div>

        <ClientOnly>
          <NewsletterForm
            :friendly-captcha="friendlyCaptcha"
            :submitting="status === NewsletterSectionTypes.NewsletterFormStatus.Busy"
            class="pb-4"
            @submit="submit"
          />
        </ClientOnly>

        <i18n-t keypath="newsletter.disclaimer" tag="p" class="txt-label-s-regular" scope="global">
          <template #privacyPolicyLink>
            <a :href="$t('jobs.newsletter.policy.url')" class="txt-label-s-bold text-main">
              {{ $t('jobs.newsletter.policy.link') }}
            </a>
          </template>
        </i18n-t>
      </template>
    </div>
  </li>
</template>

<script setup lang="ts">
import { NewsletterForm, NewsletterSectionTypes } from '@ramp106/omrjs-core-ui'
import { I18nT } from 'vue-i18n'

import { useNewsletterSubmit } from '@/composables/useNewsletterSubmit'
import { captchaSitekey, puzzleEndpoint } from '@/helpers/captcha'

const props = defineProps<{
  audience: string
  title: string
}>()

const friendlyCaptcha = {
  siteKey: captchaSitekey,
  puzzleEndpoint,
}

const { status, submit } = useNewsletterSubmit(props.audience)
</script>

<style scoped>
:deep(.frc-container) {
  height: 2.5rem;
  min-height: 2.5rem;
}

:deep(.has-border > label) {
  display: block;
  margin-bottom: 0.125rem;
}
</style>
